import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const GoogleIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeMiterlimit={10}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M21.5902 10.1802H12.2002V13.8903H17.7102C17.6002 14.8103 17.0002 16.2002 15.6702 17.1302C14.8302 17.7202 13.6902 18.1302 12.2002 18.1302C9.5602 18.1302 7.3102 16.3902 6.5102 13.9702C6.3002 13.3502 6.1802 12.6802 6.1802 11.9902C6.1802 11.3002 6.3002 10.6303 6.5002 10.0103C6.5602 9.83025 6.6302 9.64025 6.7102 9.47025C7.6602 7.34025 9.7602 5.86023 12.2002 5.86023C14.0802 5.86023 15.3402 6.67025 16.0702 7.35025L18.8902 4.59024C17.1602 2.98024 14.9002 1.99023 12.2002 1.99023C8.2902 1.99023 4.91019 4.23024 3.2702 7.50024C2.5902 8.86024 2.2002 10.3802 2.2002 11.9902C2.2002 13.6002 2.5902 15.1203 3.2702 16.4803L3.2802 16.4702V16.4803C4.9202 19.7503 8.2902 21.9902 12.2002 21.9902C14.9002 21.9902 17.1702 21.1003 18.8202 19.5703C20.7102 17.8303 21.8002 15.2602 21.8002 12.2102C21.8002 11.4002 21.7302 10.8002 21.5902 10.1802Z"
		/>
	</SvgIcon>
)

export default GoogleIconAtom
